// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.value_your_trade_card[data-v-b5c521be] {
  border: 1px solid #eee;
  border-radius: 15px;
  padding: 5px;
}
.custom_legend[data-v-b5c521be] {
  position: absolute;
  display: inline-block;
  background: #fff;
  z-index: 9;
  font-size: 12px;
  top: -12px;
  left: 30px;
  padding: 0 6px;
  color: #000;
  opacity: 0.8;
}
.card_font_sizes h5[data-v-b5c521be] {
  font-size: 12px;
  font-weight: 600;
  color: #000;
  white-space: initial;
  margin: 0;
}
.card_font_sizes p[data-v-b5c521be] {
  margin-bottom: 3px;
  white-space: initial;
  font-size: 13px;
  text-overflow: ellipsis;
  min-width: 100px;
  overflow: hidden;
}
.min-120[data-v-b5c521be] {
  min-height: 65px;
}
.ft-c-13[data-v-b5c521be] {
  font-size: 12px;
}
.max-60[data-v-b5c521be] {
  min-width: 60px;
  display: inline-block;
}
.appointment_address[data-v-b5c521be] {
  border: 1px solid #eee;
  border-radius: 15px;
  padding: 5px;
}
.appointment_address h5[data-v-b5c521be] {
  font-size: 12px;
  font-weight: 600;
  color: #000;
  white-space: initial;
  margin: 0;
}
.appointment_address p[data-v-b5c521be] {
  margin-bottom: 3px;
  white-space: initial;
  font-size: 13px;
  text-overflow: ellipsis;
  min-width: 100px;
  overflow: hidden;
}
.appointment_address img[data-v-b5c521be] {
  height: 65px;
  display: block;
  margin: auto;
}
.brake_word span[data-v-b5c521be] {
  word-break: break-word;
  display: inline-block;
}
.location_icon i[data-v-b5c521be] {
  font-size: 30px;
  opacity: 0.6;
}
.animate_bottom[data-v-b5c521be] {
  animation: animateBottom-b5c521be 2s;
  transition: 0.5s;
}
@keyframes animateBottom-b5c521be {
0% {
    transform: translateY(50px);
}
100% {
    transform: translateY(0);
}
}
@media (min-width: 1900px) {
.appointment_address h5[data-v-b5c521be] {
    font-size: 13px;
}
.appointment_address p[data-v-b5c521be] {
    font-size: 12px;
}
.custom_legend[data-v-b5c521be] {
    font-size: 13px;
}
.ft-c-13[data-v-b5c521be] {
    font-size: 13px;
}
.location_icon i[data-v-b5c521be] {
    font-size: 40px;
    opacity: 0.6;
}
}
@media (min-width: 2500px) {
.appointment_address h5[data-v-b5c521be] {
    font-size: 16px;
}
.appointment_address p[data-v-b5c521be] {
    font-size: 14px;
}
.custom_legend[data-v-b5c521be] {
    font-size: 16px;
}
.ft-c-13[data-v-b5c521be] {
    font-size: 16px;
}
.location_icon i[data-v-b5c521be] {
    font-size: 40px;
    opacity: 0.6;
}
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/SlideOutPanel/TvmAppointmentAddress/TvmAppointmentAddress.vue","webpack://./TvmAppointmentAddress.vue"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,mBAAA;EACA,YAAA;ACDF;ADGA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;ACDF;ADGA;EAEI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;ACFJ;ADJA;EASI,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;ACFJ;ADKA;EACE,gBAAA;ACHF;ADKA;EACE,eAAA;ACHF;ADKA;EAAQ,eAAA;EAAgB,qBAAA;ACDxB;ADGE;EAzCA,sBAAA;EACA,mBAAA;EACA,YAAA;ACyCF;ADFE;EAvBE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;AC4BJ;ADTE;EAhBE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AC4BJ;ADjBE;EAII,YAAA;EACA,cAAA;EACA,YAAA;ACgBN;ADZA;EACE,sBAAA;EACA,qBAAA;ACcF;ADZA;EAAiB,eAAA;EAAiB,YAAA;ACgBlC;ADdA;EACE,oCAAA;EACA,gBAAA;ACgBF;ADdA;AACE;IACE,2BAAA;ACgBF;ADdA;IACE,wBAAA;ACgBF;AACF;ADdA;AACE;IAEI,eAAA;ACeJ;ADjBA;IAKI,eAAA;ACeJ;ADZA;IACE,eAAA;ACcF;ADZA;IACE,eAAA;ACcF;ADZA;IAAiB,eAAA;IAAiB,YAAA;ACgBlC;AACF;ADfA;AACE;IAEI,eAAA;ACgBJ;ADlBA;IAKI,eAAA;ACgBJ;ADbA;IACE,eAAA;ACeF;ADbA;IACE,eAAA;ACeF;ADbA;IAAiB,eAAA;IAAiB,YAAA;ACiBlC;AACF","sourcesContent":["\n// reuseable css\n.value_your_trade_card{\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n.custom_legend {\n  position: absolute;\n  display: inline-block;\n  background: #fff;\n  z-index: 9;\n  font-size: 12px;\n  top: -12px;\n  left: 30px;\n  padding: 0 6px;\n  color: #000;\n  opacity: 0.8;\n}\n.card_font_sizes{\n  h5 {\n    font-size: 12px;\n    font-weight: 600;\n    color: #000;\n    white-space: initial;\n    margin: 0;\n  }\n  p {\n    margin-bottom: 3px;\n    white-space: initial;\n    font-size: 13px;\n    text-overflow: ellipsis;\n    min-width: 100px;\n    overflow: hidden;\n  }\n}\n.min-120{\n  min-height: 65px;\n}\n.ft-c-13{\n  font-size: 12px;\n}\n.max-60{min-width: 60px;display: inline-block}\n// end reuseable css\n  .appointment_address{\n    .value_your_trade_card();\n    .card_font_sizes();\n    img{\n      height: 65px;\n      display: block;\n      margin: auto;\n    }\n  }\n\n.brake_word span{\n  word-break: break-word;\n  display: inline-block;\n}\n.location_icon i{font-size: 30px; opacity: 0.6;}\n\n.animate_bottom{\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n@keyframes animateBottom{\n  0%{\n    transform: translateY(50px);\n  }\n  100%{\n    transform: translateY(0);\n  }\n}\n@media (min-width: 1900px) {\n  .appointment_address  {\n    h5{\n      font-size: 13px;\n    }\n    p{\n      font-size: 12px;\n    }\n  }\n  .custom_legend{\n    font-size: 13px;\n  }\n  .ft-c-13{\n    font-size: 13px;\n  }\n  .location_icon i{font-size: 40px; opacity: 0.6;}\n}\n@media (min-width: 2500px){\n  .appointment_address {\n    h5{\n      font-size: 16px;\n    }\n    p{\n      font-size: 14px;\n    }\n  }\n  .custom_legend{\n    font-size: 16px;\n  }\n  .ft-c-13{\n    font-size: 16px;\n  }\n  .location_icon i{font-size: 40px; opacity: 0.6;}\n}\n",".value_your_trade_card {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n.custom_legend {\n  position: absolute;\n  display: inline-block;\n  background: #fff;\n  z-index: 9;\n  font-size: 12px;\n  top: -12px;\n  left: 30px;\n  padding: 0 6px;\n  color: #000;\n  opacity: 0.8;\n}\n.card_font_sizes h5 {\n  font-size: 12px;\n  font-weight: 600;\n  color: #000;\n  white-space: initial;\n  margin: 0;\n}\n.card_font_sizes p {\n  margin-bottom: 3px;\n  white-space: initial;\n  font-size: 13px;\n  text-overflow: ellipsis;\n  min-width: 100px;\n  overflow: hidden;\n}\n.min-120 {\n  min-height: 65px;\n}\n.ft-c-13 {\n  font-size: 12px;\n}\n.max-60 {\n  min-width: 60px;\n  display: inline-block;\n}\n.appointment_address {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n.appointment_address h5 {\n  font-size: 12px;\n  font-weight: 600;\n  color: #000;\n  white-space: initial;\n  margin: 0;\n}\n.appointment_address p {\n  margin-bottom: 3px;\n  white-space: initial;\n  font-size: 13px;\n  text-overflow: ellipsis;\n  min-width: 100px;\n  overflow: hidden;\n}\n.appointment_address img {\n  height: 65px;\n  display: block;\n  margin: auto;\n}\n.brake_word span {\n  word-break: break-word;\n  display: inline-block;\n}\n.location_icon i {\n  font-size: 30px;\n  opacity: 0.6;\n}\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n@media (min-width: 1900px) {\n  .appointment_address h5 {\n    font-size: 13px;\n  }\n  .appointment_address p {\n    font-size: 12px;\n  }\n  .custom_legend {\n    font-size: 13px;\n  }\n  .ft-c-13 {\n    font-size: 13px;\n  }\n  .location_icon i {\n    font-size: 40px;\n    opacity: 0.6;\n  }\n}\n@media (min-width: 2500px) {\n  .appointment_address h5 {\n    font-size: 16px;\n  }\n  .appointment_address p {\n    font-size: 14px;\n  }\n  .custom_legend {\n    font-size: 16px;\n  }\n  .ft-c-13 {\n    font-size: 16px;\n  }\n  .location_icon i {\n    font-size: 40px;\n    opacity: 0.6;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
